import { faEdit, faTrashCan } from "@fortawesome/pro-regular-svg-icons";

import { IconButton } from "src/design-system/Icon";
import { Tooltip } from "src/design-system/Tooltip";

type Props = {
  rowId: string;
  entityLabel: string;
  onEdit: () => void;
  onDelete: () => void;
};

export const SdkRowActions: React.FC<Props> = ({
  rowId,
  entityLabel,
  onEdit,
  onDelete,
}) => (
  <div className="invisible flex gap-2 group-hover:visible">
    <Tooltip placement="top" title={`Edit ${entityLabel}`} asChild>
      <IconButton
        dataLoc={`edit-sdk-button-${rowId}`}
        icon={faEdit}
        size="xs"
        onClick={(event) => {
          event.stopPropagation();
          onEdit();
        }}
      />
    </Tooltip>
    <Tooltip placement="top" title={`Delete ${entityLabel}`} asChild>
      <IconButton
        dataLoc={`delete-sdk-button-${rowId}`}
        icon={faTrashCan}
        size="xs"
        onClick={(event) => {
          event.stopPropagation();
          onDelete();
        }}
      />
    </Tooltip>
  </div>
);
